import axios from '@/plugins/axios'

const appSettingApiEndPoint = 'app-settings'

export default {
    namespaced: true,

    state: {
        banners: [],
        total: 0
    },

    getters: {
        getBannerByActiveState: state => activeState => {
            if (activeState === 'All Status') {
                return state.banners
            }
            const isActive = activeState === 'Active'
            return state.banners.filter(v => v.isActive === isActive)
        }
    },

    mutations: {
        setBanners (state, banners) {
            state.banners = banners
            state.total = banners.length
        }
    },

    actions: {
        async fetchBanners ({ commit }) {
            const banners = await axios.get(`${appSettingApiEndPoint}/banners`)
            commit('setBanners', banners)
        },

        async saveBanners ({ commit }, banner) {
            if (banner.bannerUrl?.constructor === File) {
                const formData = new FormData()
                formData.append('file', banner.bannerUrl)
                const response = await axios.post(`${appSettingApiEndPoint}/upload`, formData)
                banner.bannerUrl = response.link
            }
            await axios.post(`${appSettingApiEndPoint}/banner`, banner)
        }
    }
}
